module.exports = __webpack_public_path__ + "media/images/prediction/bnr_prediction_condor-bb2d98db0dcfb5721c248123dd4dcc64.png";